module.exports = __webpack_public_path__ + "img/arrow-down.6e8deeb2.svg";